import { Provider } from '@repo/api-gw-sdk';

import type { RestoreAzureVMState } from './restoreAzureVMWizard';
import type { RestoreEc2InstanceState } from './restoreEc2InstanceWizard';
import type { RestoreGcpVMState } from './restoreGcpVMWizard';
import { AzureVmDiskConfiguration } from './steps/azureVmDiskConfiguration';
import { GcpVmDiskConfiguration } from './steps/gcp/gcpVmDiskConfiguration';
import { VolumeConfiguration } from './steps/volumeConfiguration';

import type { StepProps } from '../wizard/StepProps';

export const CrossCloudVolumeAdapter = (
  props:
    | StepProps<RestoreEc2InstanceState>
    | StepProps<RestoreAzureVMState>
    | StepProps<RestoreGcpVMState>
) => {
  const cloudProvider =
    props.wizardState.restoreAccount?.restoreAccountAttributes.cloudProvider;
  if (cloudProvider === Provider.Aws) {
    return (
      <VolumeConfiguration {...(props as StepProps<RestoreEc2InstanceState>)} />
    );
  }

  if (cloudProvider === Provider.Azure) {
    return (
      <AzureVmDiskConfiguration
        {...(props as StepProps<RestoreAzureVMState>)}
      />
    );
  }

  if (cloudProvider === Provider.Gcp) {
    return (
      <GcpVmDiskConfiguration {...(props as StepProps<RestoreGcpVMState>)} />
    );
  }

  return null;
};
